import axios from 'axios';

/**
 * Функция для получения конфигурации сенсора
 * @param {string} url url по которому нужно обращатсья к сенсору
 * @param {string} login логин для доступа к датчику
 * @param {string} password пароль для доступа к датчику
 * @returns конфигурацию сенсора или ошибку
 */
export const brickstreamGetRequest = async (url, username, password) => {
    try {
        const data = await axios
            .get(url, {
                timeout: 15000,
                auth: {
                    username,
                    password,
                },
            })
            .then((response) => response.data);
        return data;
    } catch (error) {
        return {
            error,
        };
    }
};

/**
 * Функция для реализации POST запроса к датчику BRICKSTREAM
 * @param {string} url урл к которому нужно отправить запрос
 * @param {any} data тело запроса
 * @param {string} username логин
 * @param {string} password пароль
 * @returns Ответ от датчика
 */
export const brickstreamPostRequest = async ({ url, data, username, password }) => {
    try {
        const response = await axios
            .post(url, data, {
                timeout: 15000,
                auth: {
                    username,
                    password,
                },
            })
            .then((response) => response.data)
            .catch((error) => ({ error }));
        return response;
    } catch (error) {
        return { error };
    }
};
